import React, { Component } from "react";
import { connect } from "react-redux";
import {
	Row,
	Col,
	Container,
	Card,
	CardBody,
	CardTitle,
	Table
} from "reactstrap";

const base_url_image =
	"https://locauditooh-newapp-gallery.s3.ap-south-1.amazonaws.com/";
const convertion_url = "https://d1of1iagj88x89.cloudfront.net/fit-in/512x512/";

class LocateSiteInfoBox extends Component {
	render() {
		const {
			media_owner,
			latitude,
			longitude,
			city,
			state,
			media_type,
			lighting,
			locality,
			vendor,
			brand,
			site_code,
			site_map
		} = this.props.set_marker_data;

		let image_url = "#";

		if (site_map) {
			image_url = site_map;
		}

		return (
			<Container style={{ width: "450px", height: "250px" }}>
				<Card>
					<CardBody className="">
						<CardTitle>
							Site Details{" "}
                            {site_code}
						</CardTitle>
						<Row>
							<Col xs={5}>
								<img
									style={{ cursor: "pointer", margin: 5 }}
									alt={image_url}
									width={140}
									src={convertion_url + image_url.replace(base_url_image, "")}
									onClick={() => window.open(image_url, "_blank")}
								/>
							</Col>
							<Col xs={7}>
								<Table className="mt-1" bordered striped>
									<tbody>
										<tr>
											<th>Brand</th>
											<td>{brand ? brand : "Not Available"}</td>
										</tr>
										<tr>
											<th>Media Owner</th>
											<td>{media_owner ? media_owner : "Not Available"}</td>
										</tr>
										<tr>
											<th>Media Type</th>
											<td>{media_type ? media_type : "Not Available"}</td>
										</tr>
										<tr>
											<th>Lighting</th>
											<td>{lighting ? lighting : "Not Available"}</td>
										</tr>
									</tbody>
								</Table>
							</Col>
						</Row>

						<Table className="mt-1" bordered striped>
							<tbody>
								<tr>
									<th>Latitude</th>
									<td>{latitude ? latitude : "Not Available"}</td>
									<th>Longitude</th>
									<td>{longitude ? longitude : "Not Available"}</td>
								</tr>
								<tr>
									<th>City</th>
									<td>{city ? city : "Not Available"}</td>
									<th>State</th>
									<td>{state ? state : "Not Available"}</td>
								</tr>

								<tr>
									<th>Locality</th>
									<td>{locality ? locality : "Not Available"}</td>
									<th>Vendor</th>
									<td>{vendor ? vendor : "Not Available"}</td>
								</tr>
							</tbody>
						</Table>
					</CardBody>
				</Card>
			</Container>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

export default connect(
	mapStateToProps,
	{}
)(LocateSiteInfoBox);



// WEBPACK FOOTER //
// ./src/v3/components/locateSites/locateSiteInfoBox.js